import { render, staticRenderFns } from "./CurationA.vue?vue&type=template&id=2bf2aadc&scoped=true&"
import script from "./CurationA.vue?vue&type=script&lang=js&"
export * from "./CurationA.vue?vue&type=script&lang=js&"
import style0 from "./CurationA.vue?vue&type=style&index=0&id=2bf2aadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2aadc",
  null
  
)

export default component.exports